import { Options as OptionsInterface } from '../interfaces/Options';
import Configuration from './Configuration';

export default class Options {
  private static options: OptionsInterface = {
    headers: {
      'Access-Control-Allow-Origin': Configuration.Current().apiOrigin,
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': 'POST, OPTIONS',
      'Content-Type': 'application/json',
      apiKey: Configuration.Current().apiKey,
    },
  };

  public static Instance(): OptionsInterface { return Options.options; }
}
